import { PALETTE } from '@overlayqa/shared';
/**
 * Shared Clerk appearance overrides for OverlayQA brand colors.
 *
 * Brand blue: #3468F8
 * Hover blue: #2952d6
 * Light blue bg: #eff4ff
 * Focus ring: rgba(52, 104, 248, 0.2)
 */

/** Appearance overrides for Clerk <PricingTable /> */
export const clerkPricingTableAppearance = {
  variables: {
    colorPrimary: PALETTE.brand.primary,
    colorText: PALETTE.neutral[800],
    colorTextSecondary: PALETTE.neutral[500],
    colorBackground: PALETTE.surface.card,
    borderRadius: '0.75rem',
    fontFamily: 'Plus Jakarta Sans, system-ui, -apple-system, sans-serif',
  },
  elements: {
    pricingTable: 'shadow-none',
    pricingTableCard: 'rounded-xl border border-gray-200 shadow-none',
    pricingTableCardHighlighted:
      'rounded-xl border-2 border-primary-500 shadow-none ring-1 ring-primary-200',
    formButtonPrimary:
      'h-11 rounded-xl border border-primary-500 bg-primary-500 text-sm font-medium text-white shadow-none transition hover:bg-primary-600',
    badge: 'bg-primary-50 text-primary-700 font-semibold',
    formFieldInput:
      'h-11 rounded-xl border border-gray-200 bg-white text-sm text-gray-900 shadow-none focus:border-primary-500 focus:ring-primary-500',
    formFieldLabel: 'text-sm font-medium text-gray-700',
    footerActionLink: 'font-medium text-primary-600 hover:text-primary-700',
  },
};
